export default __webpack_public_path__ + "static/media/image4.5f048275.png";